import { showError } from '../actionsApi';
import { setWaitingPopup } from './tariffConnectExtension';

export const standartErrorPopup = (dispatch) => (
  dispatch(showError()), dispatch(setWaitingPopup({ opened: true, step: 'error' }))
);
